<template>
  <div id="ecommerce_product">
    <div v-if="state == 'list'">
      <v-container v-if="currentView === 'Products'" style="width:100% !important">
        <div
          :class="{
            'ketshop-bg-color':
              selectedBot.useketshop == true &&
              selectedBot.ketshop_api_key &&
              selectedBot.ketshop_api_secret
          }"
          v-if="
            selectedBot.useketshop == true &&
              selectedBot.ketshop_api_key &&
              selectedBot.ketshop_api_secret
          "
        >
          <v-layout wrap>
            <v-flex xs12 sm2 lg2 class="pl-1">
              <img
                src="/static/img/assets/ketshop.png"
                alt
                style="max-height: 101px;width: 180px"
                v-if="
                  selectedBot.useketshop == true &&
                    selectedBot.ketshop_api_key &&
                    selectedBot.ketshop_api_secret
                "
              />
            </v-flex>
            <v-flex xs12 sm10 class="form-control text-xs-right">
              <template v-if="$store.getters.getPackage == 'premium' && selectedBot.akita_status">
                <v-btn outline color="grey" @click="exportAkita">
                  Export Akita
                </v-btn>
              </template>
              <template
                v-if="
                  check_privilege('sokochan') &&
                    selectedBot.sokochan_info &&
                    selectedBot.sokochan_info.status
                "
              >
                <template v-if="sokochanImport.show">
                  <v-chip
                    color="green"
                    v-if="sokochanImport.status === 'SUCCESS'"
                    class="white--text"
                    disabled
                  >
                    Success
                  </v-chip>
                  <v-chip
                    color="info"
                    v-else-if="sokochanImport.status === 'PENDING'"
                    class="white--text"
                    disabled
                  >
                    Pending
                  </v-chip>
                  <v-chip
                    color="error"
                    v-else-if="sokochanImport.status === 'FAILED'"
                    class="white--text"
                    disabled
                  >
                    Error
                  </v-chip>
                </template>
                <v-btn outline color="grey" @click="importSokochan" :loading="loadingProduct">
                  Import Sokochan
                </v-btn>
              </template>
              <template v-if="check_privilege('packhai') && selectedBot.packhai_status">
                <template v-if="packheiImport.show">
                  <v-chip
                    color="green"
                    v-if="packheiImport.status === 'SUCCESS'"
                    class="white--text"
                    disabled
                  >
                    Success
                  </v-chip>
                  <v-chip
                    color="info"
                    v-else-if="packheiImport.status === 'PENDING'"
                    class="white--text"
                    disabled
                  >
                    Pending
                  </v-chip>
                  <v-chip
                    color="error"
                    v-else-if="packheiImport.status === 'FAILED'"
                    class="white--text"
                    disabled
                  >
                    Error
                  </v-chip>
                </template>
                <v-btn outline color="grey" @click="importPackhai" :loading="loadingProduct">
                  Import Packhai
                </v-btn>
              </template>
              <v-btn
                :loading="loadingProduct"
                v-if="selectedBot.zortout_is_active"
                outline
                color="grey"
                @click="importZortout"
              >
                Import Zortout
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <template
          v-if="
            selectedBot.line_my_shop_is_active ||
              selectedBot.zortout_is_active ||
              selectedBot.packhai_status ||
              selectedBot.akita_status ||
              (selectedBot.sokochan_info && selectedBot.sokochan_info.status)
          "
        >
          <h2 class="mt-2">{{ $t('Product By') }}</h2>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-btn
                small
                :outline="productBy !== 'zwiz'"
                dark
                color="primary"
                class="mr-0"
                @click="selectProductBy('zwiz')"
              >
                Zwiz Shop
              </v-btn>
              <v-btn
                v-if="selectedBot.line_my_shop_is_active"
                small
                :outline="productBy !== 'lineMyShop'"
                color="primary"
                class="mr-0"
                @click="selectProductBy('lineMyShop')"
              >
                LINE SHOPPING
              </v-btn>
              <v-btn
                v-if="selectedBot.zortout_is_active"
                small
                :outline="productBy !== 'zortOut'"
                color="primary"
                class="mr-0"
                @click="selectProductBy('zortOut')"
              >
                Zort out
              </v-btn>
            </v-flex>
            <v-flex xs12 sm6 class="form-control text-xs-right">
              <template v-if="$store.getters.getPackage == 'premium' && selectedBot.akita_status">
                <v-btn small outline color="grey" @click="exportAkita">
                  Export Akita
                </v-btn>
              </template>
              <template
                v-if="
                  check_privilege('sokochan') &&
                    selectedBot.sokochan_info &&
                    selectedBot.sokochan_info.status
                "
              >
                <template v-if="sokochanImport.show">
                  <v-chip
                    color="green"
                    v-if="sokochanImport.status === 'SUCCESS'"
                    class="white--text"
                    disabled
                  >
                    Success
                  </v-chip>
                  <v-chip
                    color="info"
                    v-else-if="sokochanImport.status === 'PENDING'"
                    class="white--text"
                    disabled
                  >
                    Pending
                  </v-chip>
                  <v-chip
                    color="error"
                    v-else-if="sokochanImport.status === 'FAILED'"
                    class="white--text"
                    disabled
                  >
                    Error
                  </v-chip>
                </template>
                <v-btn outline color="grey" @click="importSokochan" :loading="loadingProduct">
                  Import Sokochan
                </v-btn>
              </template>
              <template v-if="check_privilege('packhai') && selectedBot.packhai_status">
                <template v-if="packheiImport.show">
                  <v-chip
                    color="green"
                    v-if="packheiImport.status === 'SUCCESS'"
                    class="white--text"
                    disabled
                  >
                    Success
                  </v-chip>
                  <v-chip
                    color="info"
                    v-else-if="packheiImport.status === 'PENDING'"
                    class="white--text"
                    disabled
                  >
                    Pending
                  </v-chip>
                  <v-chip
                    color="error"
                    v-else-if="packheiImport.status === 'FAILED'"
                    class="white--text"
                    disabled
                  >
                    Error
                  </v-chip>
                </template>
                <v-btn outline color="grey" @click="importPackhai" :loading="loadingProduct">
                  Import Packhai
                </v-btn>
              </template>
              <v-btn
                v-if="selectedBot.zortout_is_active"
                outline
                color="grey"
                @click="importZortout"
              >
                Import Zortout
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="loadingCategory">
          <div class="spinner text-xs-center" style="margin-top: 30px;">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </template>
        <template
          v-else-if="
            categorylist &&
              categorylist.length == 0 &&
              productBy !== 'lineMyShop' &&
              productBy !== 'zortOut'
          "
        >
          <v-flex xs12 sm11 class="form-control text-xs-center text-sm-right">
            <v-layout>
              <v-flex>
                <transfer-shop
                  v-if="
                    !salePage &&
                      !(
                        selectedBot.useketshop == true &&
                        selectedBot.ketshop_api_key &&
                        selectedBot.ketshop_api_secret
                      )
                  "
                ></transfer-shop>
              </v-flex>
              <template
                v-if="
                  (!salePage &&
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    )) ||
                    isAdmin
                "
              >
                <import-shop
                  style="display: inline-block"
                  class="export_excel"
                  v-if="
                    $store.state.centralPage.includes(selectedBot.pageid) ||
                      $store.state.robinsonPage.includes(selectedBot.pageid) ||
                      ['104716585038207', '362065616073'].includes(selectedBot.pageid) ||
                      !isFacebook
                  "
                ></import-shop>
              </template>
            </v-layout>
          </v-flex>
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 230px" />
              <h2>{{ $t('create your first category') }}</h2>
              <p>{{ $t('Click Add Category to create a category and add products') }}</p>
              <v-btn color="primary" depressed @click="showCategory = true">
                <i class="fa fa-plus middle mr-1"></i>
                {{ $t('Add new categories') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-else-if="categorylist && categorylist.length == 0 && productBy === 'zortOut'">
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
              <img src="/static/img/assets/ecommerce/slide-24.png" alt style="width: 230px" />
              <h2>{{ $t('no_products_on_zort') }}</h2>
              <p>
                {{ $t('add__products_from_zort') }}
                <a href="https://blog.zwiz.app/zortout_ordermanagement/" target="blank">{{
                  $t('how_to_use_detail')
                }}</a>
              </p>
              <v-btn color="primary" depressed @click="howToAddProductZort">
                <i class="fa fa-plus middle mr-1"></i>
                {{ $t('add_product_on_zort') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <template v-if="productBy !== 'lineMyShop'">
            <v-layout wrap>
              <v-flex xs12 sm4 md2>
                <h2 class=" mt-2">{{ $t('Category') }}</h2>
              </v-flex>
              <v-flex
                md10
                text-xs-right
                style="display: inline-flex;
                justify-content: flex-end;
                align-items: flex-end;
                flex-direction: row !important;
                flex-wrap: wrap;"
                class="category_tab"
              >
                <template v-if="!salePage && isAdmin && !isKetShop">
                  <demo-file></demo-file>
                </template>
                <template
                  v-if="
                    (!salePage &&
                      !(
                        selectedBot.useketshop == true &&
                        selectedBot.ketshop_api_key &&
                        selectedBot.ketshop_api_secret
                      )) ||
                      isAdmin
                  "
                >
                  <import-shop
                    style="display: inline-block"
                    class="export_excel"
                    v-if="
                      ($store.state.centralPage.includes(selectedBot.pageid) ||
                        $store.state.robinsonPage.includes(selectedBot.pageid) ||
                        ['104716585038207', '362065616073'].includes(selectedBot.pageid) ||
                        !isFacebook) &&
                        !isKetShop
                    "
                  ></import-shop>
                </template>
                <template v-if="!salePage">
                  <v-btn
                    small
                    fab
                    outline
                    class="primary--text"
                    @click="showCategory = true"
                    v-if="
                      !(
                        selectedBot.useketshop == true &&
                        selectedBot.ketshop_api_key &&
                        selectedBot.ketshop_api_secret
                      )
                    "
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
              </v-flex>
            </v-layout>
            <div style="overflow-x: auto;white-space: nowrap;padding-bottom: 15px">
              <filter-category
                :categories="categorylist"
                v-model="currentCategory"
                @onChangeCategory="onChangeCategory"
                :stat="filterBadge"
                :isKetShop="isKetShop"
              ></filter-category>
            </div>
            <v-divider class="mb-3"></v-divider>
          </template>

          <template v-if="currentCategory && currentCategory != null">
            <v-layout warp>
              <v-flex xs12 sm6>
                <h2 class=" mt-3">{{ $t('Products') }}</h2>
              </v-flex>
              <!-- <v-flex xs12 sm6 class="text-xs-right" v-if="!salePage">
                <sort-product :key="timestamp" @onChangeProduct="onChangeProduct"></sort-product>
              </v-flex> -->
            </v-layout>
            <template v-if="!loadingProduct">
              <v-layout wrap>
                <v-flex xs3 sm2>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    smaller
                    class="browser-default mb-2 mr-2"
                    height="36px"
                    style="min-width: 64px;min-height: 24px !important;"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-layout class="form-control text-xs-center text-sm-right justify-end">
                  <input
                    type="text"
                    size="small"
                    class="form-control ma-0 px-2 py-2"
                    v-model="search"
                    @keyup.enter="
                      pageNumber = 1
                      getProducts()
                    "
                    style="display: inline-block; max-width: 250px;height: 50px;"
                    :placeholder="$t('Search')"
                  />
                </v-layout>
                <v-flex style="display: contents;">
                  <multiselect
                    style="max-width: 100px"
                    class="ma-0 ml-2"
                    v-model="statusStatus"
                    :close-on-select="true"
                    :show-labels="false"
                    :options="statusOptions"
                    label="label"
                    selectLabel
                    selectedLabel
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    track-by="label"
                    @select="onSelectStatus"
                    v-if="!isKetShop && productBy !== 'lineMyShop'"
                  >
                  </multiselect>
                  <v-btn
                    @click="
                      pageNumber = 1
                      getProducts()
                    "
                    color="primary"
                  >
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
                <transfer-shop
                  v-if="
                    !salePage &&
                      !(
                        selectedBot.useketshop == true &&
                        selectedBot.ketshop_api_key &&
                        selectedBot.ketshop_api_secret
                      )
                  "
                  style="display: inline-block"
                ></transfer-shop>

                <div v-if="!salePage && !isKetShop">
                  <sort-product :key="timestamp" @onChangeProduct="onChangeProduct"></sort-product>
                </div>
              </v-layout>
              <!-- <v-layout wrap v-else>
                <v-flex xs12 sm1>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    smaller
                    class="browser-default mb-2"
                    height="36px"
                    style="min-width: 64px;min-height: 24px !important;"
                    hide-details
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm11 class="form-control text-xs-center text-sm-right">
                  <v-layout>
                    <v-flex>
                      <input
                        type="text"
                        class="form-control ma-0"
                        v-model="search"
                        style="display: inline-block; max-width: 300px"
                        :placeholder="$t('Search')"
                        v-if="categorylist && categorylist.length > 0 && productlist.length > 0"
                      />
                      <transfer-shop
                        v-if="
                          !salePage &&
                            !(
                              selectedBot.useketshop == true &&
                              selectedBot.ketshop_api_key &&
                              selectedBot.ketshop_api_secret
                            )
                        "
                        style="display: inline-block"
                      ></transfer-shop>
                    </v-flex>

                    <div v-if="!salePage">
                      <sort-product
                        :key="timestamp"
                        @onChangeProduct="onChangeProduct"
                      ></sort-product>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout> -->
            </template>
            <v-layout wrap v-if="!isKetShop && productBy !== 'lineMyShop'">
              <v-flex xs12 sm3 style="align-self: center;">
                <v-checkbox
                  id="cbAll"
                  :label="$t('Check all')"
                  style="display: inline-block; margin: 0; height: 32px;"
                  v-model="checkboxAll"
                  @change="clickCbAll"
                  color="primary"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm9>
                <div
                  class="text-xs-right"
                  v-if="
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    ) && productBy !== 'lineMyShop'
                  "
                >
                  <v-btn class="ma-0 mb-1 mr-1" @click="deleteSelected" color="primary" outline>
                    <i class="fas fa-trash mr-1"></i>
                    {{ $t('delete_products_selected') }}
                  </v-btn>
                  <v-btn class="ma-0 mb-1 mr-1" @click="showDialog = true" color="primary" outline>
                    <i class="fas fa-trash mr-1"></i>
                    {{ $t('delete_all') }}
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <template v-if="!loadingProduct">
              <v-layout wrap>
                <template v-if="!salePage">
                  <v-flex
                    xs12
                    sm12
                    class="my-2"
                    v-if="
                      !(
                        selectedBot.useketshop == true &&
                        selectedBot.ketshop_api_key &&
                        selectedBot.ketshop_api_secret
                      ) && productBy === 'zwiz'
                    "
                  >
                    <v-premium-plan-layout
                      class="add-conversation"
                      style="cursor: pointer; min-height: 100px;"
                      text="Number of products, you have reached the limit of the package. If you want to increase the amount, start at 500 baht/month, upgrade now!"
                      :isLocked="
                        ($store.getters.getPackage != 'premium' || isCoachlab) &&
                          productlist.length >= maxProduct
                      "
                      @click="
                        () =>
                          ($store.getters.getPackage != 'premium' || isCoachlab) &&
                          productlist.length >= maxProduct
                            ? {}
                            : onAddNewProduct()
                      "
                    >
                      <div
                        style="position:absolute; top: 50%; margin-top: -30px; left: 0; right: 0"
                      >
                        <div class="text-xs-center">
                          <h2 style="color:#969595">
                            <i class="fa fa-plus"></i>
                          </h2>
                          <p>{{ $t('Add new product') }}</p>
                        </div>
                      </div>
                    </v-premium-plan-layout>
                    <!-- <div
                      class="add-conversation"
                      @click="onAddNewProduct"
                      style="position:relative;"
                    >
                      <template
                        v-if="
                          ($store.getters.getPackage != 'premium' || isCoachlab) &&
                            productlist.length >= maxProduct
                        "
                      >
                        <v-premium-plan-popup
                          :showAll="false"
                          marginTop="65"
                          :size="'small'"
                          text="Number of products, you have reached the limit of the package. If you want to increase the amount, start at 500 baht/month, upgrade now!"
                        ></v-premium-plan-popup>
                      </template>
                    </div> -->
                  </v-flex>
                </template>
              </v-layout>

              <v-layout wrap v-if="categorylist && filterProducts && filterProducts.length > 0">
                <v-flex
                  xs12
                  sm11
                  class="text-xs-center text-sm-right"
                  style="flex-basis: 100% !important;max-width:100% !important"
                >
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <template v-if="categorylist && filterProducts && filterProducts.length > 0">
                  <template v-for="(product, index) in filterProducts">
                    <v-flex sm2-4 class="pa-1" :key="'product_' + product.id">
                      <product
                        @assignCb="assignCb"
                        :cbAll.sync="cbAll"
                        :indexProduct="index"
                        :productBy="productBy"
                        @changeproductstatus="onChangeProductStatus"
                        v-model="filterProducts[index]"
                        @productDeleted="onDeleteProduct(index)"
                        @getAllproduct="getProducts"
                        :category="categorylist"
                        :selectCategory="currentCategory"
                        @onSelectedProduct="onSelectedProduct(index, product)"
                      ></product>
                    </v-flex>
                  </template>
                </template>
              </v-layout>
              <v-layout
                wrap
                v-if="categorylist && filterProducts && filterProducts.length > 0"
                class="mt-3"
              >
                <v-flex xs12 sm1>
                  <v-select
                    :items="pagelimit"
                    solo
                    v-model="size"
                    @change="onChangeLimit"
                    small
                    class="mb-2"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <div class="spinner text-xs-center">
                <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
              </div>
            </template>
            <div class="mb-5 mt-5"></div>
          </template>
          <template v-else>
            <div class="text-xs-center" style="margin: 35px 0">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 300px" />
              <h2>{{ $t('Select category') }}</h2>
              <v-btn depressed color="primary" @click="showCategory = true">
                {{ $t('Add new categories') }}
              </v-btn>
            </div>
          </template>
        </template>
        <categories
          v-model="categorylist"
          @close="showCategory = false"
          :show="showCategory"
          :productBy="productBy"
          @onCategoryChange="onCategoryChange"
          @deleteCategory="deleteCategory"
        ></categories>
      </v-container>
    </div>
    <div v-else-if="state == 'add-product'">
      <template v-if="categorylist && state == 'add-product'">
        <v-container>
          <modal-add-product
            :selectCategory="currentCategory"
            :category="categorylist"
            @onAddProduct="addProduct"
            @close="close"
          ></modal-add-product>
        </v-container>
      </template>
    </div>
    <div v-else-if="state == 'edit-product'">
      <template v-if="categorylist && currentProduct">
        <v-container>
          <modal-edit-product
            v-model="currentProduct"
            @close="close"
            @onSaveProduct="closeEditProduct"
            :selectCategory="currentCategory"
            :category="categorylist"
          ></modal-edit-product>
        </v-container>
      </template>
    </div>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card v-if="showDialog">
        <div style="position: absolute; right: 0px;">
          <v-btn fab small flat @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="text-xs-center">
            <i
              class="fas fa-info-circle mb-3"
              style="font-size: 50px; color:#ed1e78; align-self: center;"
            ></i>
          </div>
          <div class="text-xs-center" style="background: #ffe1ee; padding: 35px;">
            <div class="mb-1">{{ $t('confirm_delete') }}</div>
            <div class="form-control left-align" :class="{ 'has-error': errors.has('username') }">
              <input
                type="text"
                class="input form-control"
                aria-describedby="userid"
                :placeholder="$t('type_to_confirm_delete')"
                v-model="confirmDelete"
                v-validate="'required'"
                data-vv-as="Username"
                data-vv-name="username"
              />
            </div>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn outline color="primary" class="" @click="showDialog = false">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn depressed color="primary" @click="saveDeleteAll">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './Product'
import ModalAddProduct from './ModalAddProduct'
import ModalEditProduct from './ModalEditProduct'
import SelectCategory from './SelectCategory'
import FilterCategory from './FilterCategory'
import Categories from './Categories'
import ModalHelp from '@/components/elements/ModalHelp'
import TransferShop from './TransferShop.vue'
import SortProduct from './SortProduct.vue'
import demoFile from './demoFile.vue'
import Promotion from './Promotion.vue'
import Wholesale from './Wholesale'
import dayjs from 'dayjs'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import ImportShop from './ImportShop.vue'
import XLSX from 'xlsx'
import api from '@/api'
import Multiselect from 'vue-multiselect'

export default {
  props: ['salePage'],
  data: function() {
    return {
      statusOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Active'),
          value: true
        },
        {
          label: this.$t('Inactive'),
          value: false
        }
      ],
      statusStatus: {
        label: this.$t('All'),
        value: ''
      },
      cbAll: [],
      checkboxAll: false,
      confirmDelete: '',
      showDialog: false,
      productBy: 'zwiz',
      pageNumber: 1,
      size: 10,
      currentProduct: undefined,
      currentCategory: 'all',
      currentFilter: 'all',
      productlist: [],
      categorylist: undefined,
      selectedProduct: null,
      showCategory: false,
      showModal: false,

      loadingProduct: true,
      loadingCategory: true,

      pagelimit: [10, 25, 50],

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      productCount: 0,
      totalRecords: 0,

      search: '',
      state: 'list',
      timestamp: dayjs().format('x'),
      packheiImport: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      sokochanImport: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      currentView: null,
      isAdmin: false
    }
  },
  components: {
    Multiselect,
    Product,
    ModalAddProduct,
    ImportShop,
    ModalEditProduct,
    Categories,
    SelectCategory,
    FilterCategory,
    ModalHelp,
    TransferShop,
    SortProduct,
    demoFile,
    Promotion,
    Wholesale
  },
  async mounted() {
    const vm = this
    vm.currentView = vm.$route.query.tab
    vm.getStartComponent()
    vm.getCountSpecialCategory()
    try {
      const loginType = vm.$store.state.loginType
      if (loginType == 'admin') {
        vm.isAdmin = true
      } else {
        vm.isAdmin = false
      }
    } catch (err) {
      console.log(err)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      isFacebook: 'isFacebook',
      products: 'getProducts',
      getLoadingProduct: 'getLoadingProduct',
      getTotalProduct: 'getTotalProduct'
    }),
    maxProduct() {
      let package_config = this.getPackageConfig()
      let max = package_config.products
      return this.isCoachlab ? 20 : max
    },
    filterProducts: function() {
      return this.productlist
    },
    pageCount: function() {
      const vm = this
      let l = this.productCount
      let s = this.size
      if (vm.productBy === 'lineMyShop') {
        return l
      } else {
        return Math.ceil(vm.totalRecords / s)
      }
    },
    isKetShop() {
      return (
        this.selectedBot.useketshop == true &&
        this.selectedBot.ketshop_api_key &&
        this.selectedBot.ketshop_api_secret
      )
    }
  },
  methods: {
    onSelectStatus(param) {
      const vm = this
      vm.statusStatus = param
    },
    async deleteSelected() {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('confirm_delete_products'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.$store.dispatch('loading')
        let res = await vm.delete(
          `products?ids=${vm.cbAll.toString()}&pageid=${vm.selectedBot.pageid}`
        )
        if (res.responsecode === 200) {
          vm.pageNumber = 1
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: ``,
            type: 'success'
          })
          vm.cbAll = []
          vm.getStartComponent()
        }
        vm.$store.dispatch('loading')
      }
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter(v => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      // if (!this.cbAll.length) {
      //   this.cbAll = this.productlist.map(v => v.id)
      //   this.checkboxAll = true
      // } else {
      //   this.cbAll = []
      //   this.checkboxAll = false
      // }

      if (this.checkboxAll) {
        this.productlist.map(v => {
          this.cbAll.push(v.id)
        })
        this.checkboxAll = true
      } else {
        this.cbAll = this.cbAll.filter(elem => {
          return !this.productlist.some(ele => {
            return ele.id === elem
          })
        })

        this.checkboxAll = false
      }
    },
    async saveDeleteAll() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        if (vm.confirmDelete === 'confirm') {
          vm.$store.dispatch('loading')
          let res = await vm.delete(`page/${vm.selectedBot.pageid}/delete-all-product`, {
            data: {
              ref: this.productBy.toUpperCase()
            }
          })
          if (res.success) {
            vm.pageNumber = 1
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: ``,
              type: 'success'
            })
            vm.confirmDelete = ''
            vm.showDialog = false
            vm.getStartComponent()
          }
          vm.$store.dispatch('loading')
        }
      }
    },
    async getAllproduct() {
      this.$store.state.ecommerce.products = []
      if (
        (this.selectedBot.useketshop == true &&
          this.selectedBot.ketshop_api_key &&
          this.selectedBot.ketshop_api_secret) ||
        this.productBy === 'lineMyShop' ||
        this.productBy === 'zwiz'
      ) {
        await this.getProducts()
        this.getCountSpecialCategory()
      }
    },
    howToAddProductZort() {
      window.open('https://secure.zortout.com/Product/list?', '_blank')
    },
    async getStartComponent() {
      this.$store.dispatch('updateBotDetail')
      await this.getCategories()
      await this.getProducts()

      if (this.check_privilege('packhai') && this.selectedBot.packhai_status) {
        await this.checkPackheiImportStatus()
      }
      if (
        this.check_privilege('sokochan') &&
        this.selectedBot.sokochan_info &&
        this.selectedBot.sokochan_info.status
      ) {
        await this.checkSokochanImportStatus()
      }
    },
    selectProductBy(type) {
      const vm = this
      vm.productBy = type
      this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      vm.getStartComponent()
    },
    async checkPackheiImportStatus() {
      try {
        let response = await this.get('packhai/stock/import-status', {
          params: {
            pageid: this.selectedBot.pageid
          }
        })
        if (response.success) {
          let data = response.result
          this.packheiImport.status = data.status
        }
        return response
      } catch (error) {
        throw error
      }
    },
    async checkSokochanImportStatus() {
      try {
        let response = await this.get(`sokochan/${this.selectedBot.pageid}/check-import-status`, {
          params: {
            pageid: this.selectedBot.pageid
          }
        })
        if (response.success) {
          let data = response.result
          this.sokochanImport.status = data.status
        }
        return response
      } catch (error) {
        throw error
      }
    },
    async importSokochan() {
      this.loadingProduct = true
      try {
        let response = await this.post(
          `sokochan/${this.selectedBot.pageid}/update-stock-list`,
          {},
          {
            params: {
              pageid: this.selectedBot.pageid
            }
          }
        )
        if (response.success) {
          this.sokochanImport.show = true
          this.sokochanImport.loading = true
          this.sokochanImport.status = 'PENDING'
          let count = 0
          this.sokochanImport.interval = setInterval(async () => {
            let response = await this.checkSokochanImportStatus()
            count = count + 1
            if (count === 4) {
              this.loadingProduct = false
              this.packheiImport.loading = false
              if (this.packheiImport.interval) clearInterval(this.packheiImport.interval)
              await this.$swal.fire({
                title: this.$t('Warning!'),
                type: 'warning',
                text: this.$t('please_wait_moment'),
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
            }
            if (this.sokochanImport.status == 'SUCCESS') {
              this.loadingProduct = false
              this.sokochanImport.loading = false
              if (this.sokochanImport.interval) clearInterval(this.sokochanImport.interval)
              await this.$swal.fire({
                title: this.$t('success'),
                type: 'success',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              window.location.reload()
            } else if (this.sokochanImport.status == 'FAILED') {
              this.loadingProduct = false
              this.sokochanImport.loading = false
              if (this.sokochanImport.interval) clearInterval(this.sokochanImport.interval)
              if (response.result.status_message) {
                await this.$swal.fire({
                  title: this.$t('Error'),
                  type: 'error',
                  text: response.result.status_message,
                  confirmButtonText: this.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
              }
            }
          }, 5000)
        }
      } catch (error) {
        if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await this.$swal.fire({
            title: this.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await this.$swal.fire({
            title: this.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
        this.loadingProduct = false
      }
    },
    async checkZortoutImportStatus() {
      try {
        let response = await this.get(`zortout/${this.selectedBot.pageid}/check-sync-product`)
        if (response.success) {
          return response.result
        } else {
          throw new Error(response.message)
        }
        return response
      } catch (error) {
        throw error
      }
    },
    async importZortout() {
      this.loadingProduct = true
      this.$store.dispatch('loading')

      try {
        const response = await this.get(`zortout/${this.selectedBot.pageid}/sync-product`)
        if (response.success) {
          let count = 0
          const interval = setInterval(async () => {
            if (count === 10) {
              if (interval) clearInterval(interval)
              this.loadingProduct = false

              await this.$swal.fire({
                type: 'info',
                title: this.$t('system_working_background'),
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              this.$store.dispatch('loading')
            } else {
              count = count + 1

              const { status, status_message } = await this.checkZortoutImportStatus()

              if (status == 'SUCCESS') {
                if (interval) clearInterval(interval)
                this.loadingProduct = false

                await this.$swal.fire({
                  title: this.$t('success'),
                  type: 'success',
                  confirmButtonText: this.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
                this.$store.dispatch('loading')
                window.location.reload()
              } else if (status == 'FAILED') {
                if (interval) clearInterval(interval)
                this.loadingProduct = false

                await this.$swal.fire({
                  title: this.$t('error'),
                  text: status_message,
                  type: 'error',
                  confirmButtonText: this.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
                this.$store.dispatch('loading')
              }
            }
          }, 5000)
        } else {
          if (response.response && response.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
            await this.$swal.fire({
              title: this.$t('zort_limit_import_title'),
              text: this.$t('zort_limit_import_message'),
              type: 'error'
            })
          }
          this.loadingProduct = false
          this.$store.dispatch('loading')
        }
      } catch (error) {
        if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await this.$swal.fire({
            title: this.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await this.$swal.fire({
            title: this.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
        this.$store.dispatch('loading')
        this.loadingProduct = false
      }
    },
    async importPackhai() {
      this.loadingProduct = true
      try {
        let response = await this.post(
          'packhai/update-stock-list',
          {},
          {
            params: {
              pageid: this.selectedBot.pageid
            }
          }
        )
        if (response.success) {
          this.packheiImport.show = true
          this.packheiImport.loading = true
          this.packheiImport.status = 'PENDING'
          let count = 0
          this.packheiImport.interval = setInterval(async () => {
            let response = await this.checkPackheiImportStatus()
            count = count + 1
            if (count === 4) {
              await this.$swal.fire({
                title: this.$t('error'),
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              this.loadingProduct = true
              this.packheiImport.loading = false
              if (this.packheiImport.interval) clearInterval(this.packheiImport.interval)
            }
            if (this.packheiImport.status == 'SUCCESS') {
              this.loadingProduct = false
              this.packheiImport.loading = false
              if (this.packheiImport.interval) clearInterval(this.packheiImport.interval)
              await this.$swal.fire({
                title: this.$t('success'),
                type: 'success',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })

              window.location.reload()
            } else if (this.packheiImport.status == 'FAILED') {
              if (response.status_message) {
                await this.$swal.fire({
                  title: this.$t('error'),
                  type: response.status_message,
                  confirmButtonText: this.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
              }
              this.loadingProduct = true
              this.packheiImport.loading = false
              if (this.packheiImport.interval) clearInterval(this.packheiImport.interval)
            }
          }, 5000)
        }
      } catch (error) {
        if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await this.$swal.fire({
            title: this.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await this.$swal.fire({
            title: this.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
        this.loadingProduct = false
      }
    },
    exportAkita() {
      var dataWS = null
      var json = this.productlist.map(product => {
        var photourl = []
        try {
          if (product.photourl != '') photourl = product.photourl.split(';;')
        } catch (error) {}

        var variants = []

        try {
          variants = JSON.parse(product.productstockcategories)
        } catch (error) {}
        if (variants.length == 0) variants = [{ level: 0, name: 'ตัวเลือก' }]

        if (photourl.length == 0) {
          photourl[0] =
            'https://zwizai.s3.amazonaws.com/ecommerce/1583138880495image-not-found-big-300x169.png'
        }
        return product.productstock.map(stock => {
          var stock_variants = []
          var price = 0

          if (stock[4]) {
            price = stock[4]
          } else if (stock[3]) {
            price = stock[3]
          } else if (product.discountprice) {
            price = product.discountprice
          } else {
            price = product.price
          }
          try {
            stock_variants = stock[1].split('/')
          } catch (error) {}
          return {
            code: product.code,
            name: product.name,
            description: product.description,
            variant1: variants[0].name,
            variant2: variants.length > 1 ? variants[1].name : '',
            brand: '',
            photo1: photourl[0],
            photo2: photourl[1] ? photourl[1] : '',
            photo3: photourl[2] ? photourl[2] : '',
            photo4: photourl[3] ? photourl[3] : '',
            photo5: photourl[4] ? photourl[4] : '',
            'sku.code': stock[5],
            'sku.barcode': '',
            'sku.variant1': stock_variants[0],
            'sku.variant2': stock_variants.length > 1 ? stock_variants[1] : '',
            'sku.cost': '',
            'sku.price': price
          }
        })
      })
      json = [].concat(...json)

      dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwiz-product.xlsx')
    },
    async close() {
      this.state = 'list'
      await this.$nextTick()
      goTo(0)
    },
    async onChangeProduct() {
      await this.getProducts()
      this.timestamp = dayjs().format('x')
    },
    async onChangeLimit(value) {
      this.size = value
      this.pageNumber = 1
      $('html, body').animate({ scrollTop: 0 })
      await this.getProducts()
    },
    onClickPageinate: function(pageNum) {
      const vm = this
      vm.checkboxAll = false
      vm.pageNumber = pageNum
      $('html, body').animate({ scrollTop: 0 })
      vm.getProducts()
    },
    onAddNewProduct: function() {
      var vm = this
      if (
        (vm.$store.getters.getPackage === 'premium' && !vm.isCoachlab) ||
        (vm.$store.getters.getPackage !== 'premium' && vm.productlist.length < vm.maxProduct) ||
        (vm.isCoachlab && vm.productlist.length < vm.maxProduct)
      ) {
        vm.state = 'add-product'
      }
      this.timestamp = dayjs().format('x')
    },
    closeEditProduct: async function() {
      var vm = this
      await vm.getAllproduct()
      vm.$store.dispatch('loading')
      vm.state = 'list'
      this.timestamp = dayjs().format('x')
    },
    onSelectedProduct: function(index, product) {
      this.currentProduct = product
      this.state = 'edit-product'
    },
    onCategoryChange: function() {
      let vm = this
    },
    deleteCategory(categoryid) {
      this.productlist = this.productlist.filter(el => {
        return el.categoryid != categoryid
      })
      if (this.currentCategory == categoryid) {
        this.currentCategory = 'all'
      }
    },
    getCategories() {
      let vm = this
      return new Promise((resolve, reject) => {
        vm.loadingCategory = true
        if (!vm.selectedBot) {
          reject()
        }
        var data = {
          pageid: vm.selectedBot.pageid
        }
        if (
          vm.selectedBot.useketshop == true &&
          vm.selectedBot.ketshop_api_key &&
          vm.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }
        api.getCategories(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response && response.categorylist.length !== 0) {
            if (vm.productBy === 'zortOut') {
              response.categorylist = response.categorylist.filter(
                item => item.ref_code && item.ref_code.includes('ZORTOUT')
              )
            } else {
              response.categorylist = response.categorylist.filter(
                item => !item.ref_code || (item.ref_code && !item.ref_code.includes('ZORTOUT'))
              )
            }
          }

          vm.categorylist = response.categorylist
          vm.loadingCategory = false
          resolve()
        })
      })
    },

    getCountSpecialCategory: function() {
      let vm = this
      api['getCountSpecialCategory'](vm.selectedBot.pageid, function(error, response) {
        if (error) {
          console.log('error', error)
        } else {
          vm.filterBadge = {
            all: response.total_product,
            sales: response.total_product_on_sale,
            soldout: response.total_product_almost_out_of_stock
          }
        }
      })
    },
    getProducts: function() {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = { pageid: vm.selectedBot.pageid }
        vm.loadingProduct = true
        vm.productlist = []
        let apiUrl = 'getProducts'

        data['limit'] = vm.size
        data['offset'] = vm.pageNumber * vm.size - vm.size
        data['page'] = vm.pageNumber
        if (vm.isKetShop) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }
        if (vm.productBy === 'lineMyShop') {
          apiUrl = 'getProductLineMyShop'
          if (vm.search !== '') {
            data['skus'] = vm.search
          }
        }
        if (vm.selectedBot.zortout_is_active) {
          data['ref_code'] = 'zwiz'
        }
        if (vm.productBy === 'zortOut') {
          data['ref_code'] = 'zortout'
        }
        if (vm.currentCategory !== 'all') {
          data['categoryid'] =
            vm.currentCategory === 'soldout'
              ? 'product_almost_out_of_stock'
              : vm.currentCategory === 'sales'
              ? 'product_on_sale'
              : vm.isKetShop
              ? vm.currentCategory.replace('ketshop_', '')
              : vm.currentCategory
        }
        if (vm.search !== '') {
          data['product_name'] = vm.search
        }
        if (vm.statusStatus.value !== '') {
          data['is_active'] = vm.statusStatus.value
        }

        api[apiUrl](data, function(error, response) {
          if (error && m.productBy === 'lineMyShop') {
            vm.$swal
              .fire({
                title: vm.$t('please_connect_linemyshop'),
                type: 'warning',
                showCancelButton: false,
                reverseButtons: true,
                confirmButtonText: vm.$t('go_connect_linemyshop'),
                confirmButtonColor: vm.$vuetify.theme.primary
              })
              .then(result => {
                if (result.value) {
                  vm.$router.push('partner').catch(() => {})
                }
              })
            // vm.loadingProduct = false
            resolve()
            return
          } else if (error) {
            vm.$swal.fire({
              title: vm.$t('Unsuccessful'),
              type: 'warning',
              showCancelButton: false,
              reverseButtons: true,
              confirmButtonText: vm.$t('approved'),
              confirmButtonColor: vm.$vuetify.theme.primary
            })
          }

          if (
            vm.productBy === 'lineMyShop' &&
            _.get(response, 'data', '') &&
            _.get(response, 'data.success', '')
          ) {
            vm.productlist = response.data.result
            vm.productCount = response.data.totalPage
            vm.totalRecords = response.data.totalRow
          }

          if (response && response.responsecode === 200) {
            vm.productlist = response.productlist
            vm.productCount = response.productlist_length
            vm.totalRecords = response.total_records
            if (response.productlist.length > 0) {
              vm.checkboxAll = vm.productlist.every(o => vm.cbAll.some(v => v === o.id))
            }
          }
          if (!vm.selectedBot.zortout_is_active && response && response.productlist.length !== 0) {
            response.productlist = response.productlist.filter(product => {
              if (
                !product.ref_code ||
                (product.ref_code && !product.ref_code.includes('ZORTOUT'))
              ) {
                return product
              }
            })
          }
          vm.loadingProduct = false
          resolve()
        })
      })
    },
    addProduct: async function(product) {
      this.pageNumber = 1
      await this.getAllproduct()
      this.$store.dispatch('loading')
      this.timestamp = dayjs().format('x')
    },
    onSelectProduct: function(val) {
      this.selectedProduct = this.productlist.find(product => {
        return product.id == val
      })
    },
    onLoadCategory: function(payload) {
      // console.log(payload)
      if (payload && payload.length > 0) {
        // this.getProducts()
      }
    },
    onChangeCategory: function(payload) {
      this.currentCategory = payload
      this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      this.getProducts()
    },
    onDeleteProduct: function(index) {
      // vm.productlist.splice(index,1)
      this.getAllproduct()
      this.timestamp = dayjs().format('x')
    },
    onChangeProductStatus(payload) {
      var index = this.productlist.findIndex(el => {
        return payload.id == el.id
      })
      this.$set(this.productlist[index], 'status', payload.status)
    }
  },
  watch: {
    showModal: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    showCategory: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    currentCategory: function(newVal, oldVal) {
      if (newVal != null) {
        this.pageNumber = 1
        // this.getProducts(function() {})
      }
    }
  },
  beforeDestroy: function() {
    if (this.packheiImport.interval) clearInterval(this.packheiImport.interval)
    if (this.sokochanImport.interval) clearInterval(this.sokochanImport.interval)
  }
}
</script>

<style lang="scss" scoped>
.ketshop-bg-color {
  background-color: #262626;
}
@media only screen and (max-width: 600px) {
  .category_tab {
    display: inline-flex !important;
    justify-content: flex-end !important;
    flex-direction: column !important;
  }
  .export_excel {
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Products.vue